import React from 'react';
import styles from './ContentD2.scss';
import blockStyles from '@baseStyles/block.scss';
import Slider from '@components/base/Slider/Slider';
import 'swiper/css/free-mode';
import Button from "@components/base/Button/Button";
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import language from "@lang/language";
import useDataFileAction from "@hooks/useDataFileAction";

const ContentD2 = ({data, color = ''}) => {

	if (!data || !data.defaultCategory || data.defaultCategory.length === 0) {
		return;
	}

	const {executeAction, ModalPortal} = useDataFileAction();

	return (
	  <>
		  {/* Intro */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  <div className={blockStyles.baseContainerHolder}>
			  <ContentB1 title={data.blockTitle} desc={data.blockDesc}/>
		  </div>

		  <div className={`${styles.container} ${color ? blockStyles[color] : ''}`}>
			  {/* Slider */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <Slider
				slidesPerView={'auto'}
				autoplay={false}
				centerInsufficientSlides={true}
				startHintAnimation={data.startHintAnimation}
				hintAnimationParams={data.hintAnimationParams}>
				  {data.defaultCategory.map((item, key) => (
					<a href={item.href} target={'_blank'} key={key}>
						<div className={styles.designContainer}>
							<img
							  src={item.img}
							  alt={item.name}
							  title={item.name + language.shBGTitle}
							  width={360}
							  height={542}
							/>
							<span>{item.name}</span>
						</div>
					</a>
				  ))}
			  </Slider>

			  {/* Button */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <div className={styles.buttonContainer}>
				  <Button
					value={data.buttonText}
					onClick={() => executeAction(data)}
				  />
			  </div>
		  </div>

		  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  {ModalPortal}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
	  </>
	)
}

export default ContentD2;
